import React from "react";
import * as ExcelJS from "exceljs";
import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import getParticipantesFinalesArt from '../../services/participant/participantesFinalesArtService';
import { getArbolDirectorios } from '../../services/dashboardInicial/getArbolDirectorios';

import logoART from "../../assets/logo_participantesF/ART.png";

const COLORS = {
  AZUL_OSCURO: "FF0B2C5D",
  AZUL_MARINO: "FF082444",
  AZUL_CLARO: "FFD9E3F0",
  AZUL_CLARO_2: "FFE8EFF8",
  MARRON: "FF7A4A2E",
  MARRON_CLARO: "FFF2E2D5",
  CAFE_OSCURO: "FF5C3A1E",
  CAFE_CLARO: "FFEDE3D8",
  VERDE_OSCURO: "FF1F6B3A",
  VERDE_CLARO: "FFE3F2E5",
  GRIS: "FF6E6E6E",
  GRIS_CLARO: "FFEAEAEA",
  AMARILLO_CLARO: "FFFFF2CC",
  BLANCO: "FFFFFFFF",
};
const imageToBase64 = async (imagePath) => {
  const response = await fetch(imagePath);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () =>
      resolve(reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, ""));
    reader.readAsDataURL(blob);
  });
};
const withSoftBorder = (cell) => {
  cell.border = {
    top: { style: "thin", color: { argb: COLORS.BLANCO } },
    left: { style: "thin", color: { argb: COLORS.BLANCO } },
    right: { style: "thin", color: { argb: COLORS.BLANCO } },
    bottom: { style: "thin", color: { argb: COLORS.BLANCO } },
  };
};
const createHeader = (sheet, range, text, bgColor) => {
  sheet.mergeCells(range);
  const cell = sheet.getCell(range.split(":")[0]);
  cell.value = text.toUpperCase();
  cell.font = { size: 10, color: { argb: COLORS.BLANCO } };
  cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  withSoftBorder(cell);
};
const createSubHeader = (sheet, cellAddr, text, bgColor) => {
  const cell = sheet.getCell(cellAddr);
  cell.value = text ? text.toUpperCase() : "";
  cell.font = { size: 10, color: { argb: COLORS.AZUL_OSCURO } };
  cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  withSoftBorder(cell);
};

const transformarRutaARutaLista = (ruta) =>
  ruta.split('/').filter(segment => segment);

const contieneArchivo = (dataDirectorios, nombres) => {
  let currentNode = dataDirectorios.find(node => node.name === nombres[0]);

  for (let i = 1; i < nombres.length; i++) {
    if (!currentNode || !currentNode.children) return false;
    currentNode = currentNode.children.find(child => child.name === nombres[i]);
  }

  if (currentNode && currentNode.children?.length > 0) {
    return currentNode.children.some(child => child.type === "file");
  }

  return false;
};


const ExportExcelBodecom = ({ proyectoCodigo }) => {
  const exportExcel = async () => {
    const response = await getParticipantesFinalesArt(proyectoCodigo);
    if (response.status !== 200 || !response.data?.length) {
      message.warning("No hay participantes para exportar");
      return;
    }
    const participantes = response.data;

    const { data: dataDirectorios } = await getArbolDirectorios();
    const participantesValidados = participantes.map((p) => {
      const rutas = [
        {
          ruta: `${p.codigo_proyecto}/Participantes/${p.numero_identificacion}/Cédula`,
          campo: 'validado_registraduria',
        },
        {
          ruta: `${p.codigo_proyecto}/Participantes/${p.numero_identificacion}/Antecedentes Procuraduría`,
          campo: 'validado_procuraduria',
        },
        {
          ruta: `${p.codigo_proyecto}/Participantes/${p.numero_identificacion}/Antecedentes Policía`,
          campo: 'validado_policia',
        },
      ];

      const updated = { ...p };

      rutas.forEach(({ ruta, campo }) => {
        const existe = contieneArchivo(
          dataDirectorios,
          transformarRutaARutaLista(ruta)
        );

        updated[campo] = existe ? 'SI' : 'NO';
      });

      return updated;
    });

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("FORMATO ART", {
      views: [{ showGridLines: false, zoomScale: 30 }],
    });

    for (let col = 1; col <= 76; col++) {
      sheet.getColumn(col).width = 13;
    }

    sheet.mergeCells("F1:AE1");
    const t = sheet.getCell("F1");
    t.value = "ESTRUCTURACIÓN Y EJECUCIÓN DE PROYECTOS";
    t.font = { bold: true, size: 15, color: { argb: COLORS.AZUL_OSCURO } };
    t.alignment = { vertical: "middle", horizontal: "center" };

    sheet.mergeCells("A1:E2");

    sheet.getRow(1).height = 35;
    sheet.getRow(2).height = 70;

    for (let row = 1; row <= 2; row++) {
      for (let col = 1; col <= 31; col++) {
        const cell = sheet.getCell(row, col);
        cell.border = {
          top: { style: "medium", color: { argb: COLORS.AZUL_OSCURO } },
          left: { style: "medium", color: { argb: COLORS.AZUL_OSCURO } },
          right: { style: "medium", color: { argb: COLORS.AZUL_OSCURO } },
          bottom: { style: "medium", color: { argb: COLORS.AZUL_OSCURO } },
        };
      }
    }

    ["A1", "F1", "A2", "F2", "P2", "U2", "X2"].forEach((cellAddr) => {
      sheet.getCell(cellAddr).alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });




    const logoBase64 = await imageToBase64(logoART);
    const imageId = workbook.addImage({
      base64: logoBase64,
      extension: "png",
    });

    sheet.addImage(imageId, {
      tl: { col: 0.5, row: 0.8 },
      br: { col: 4.5, row: 1.8 },
    });

    sheet.getCell("A1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };


    sheet.mergeCells("F2:O2");
    sheet.getCell("F2").value =
      "DIRECCIÓN DE ESTRUCTURACIÓN Y EJECUCIÓN DE PROYECTOS/SUBDIRECCIÓN DE DESARROLLO ECONÓMICO";

    sheet.mergeCells("P2:T2");
    sheet.getCell("P2").value = "Código: FM-EEP-60";

    sheet.mergeCells("U2:W2");
    sheet.getCell("U2").value = "Versión: 01";

    sheet.mergeCells("X2:AE2");
    sheet.getCell("X2").value = "Fecha de publicación: 17-04-2023";

    ["F2", "P2", "U2", "X2"].forEach((c) => {
      sheet.getCell(c).font = { size: 14, color: { argb: COLORS.AZUL_OSCURO } };
      sheet.getCell(c).alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });


    sheet.getRow(4).height = 45;
    createHeader(sheet, "A4:A4", "No.", COLORS.AZUL_OSCURO);
    createHeader(sheet, "B4:L4", "DATOS BÁSICOS", COLORS.AZUL_OSCURO);
    createHeader(sheet, "M4:Q4", "NIVEL ESCOLARIDAD (MARQUE X)", COLORS.MARRON);
    createHeader(sheet, "R4:AD4", "POBLACIÓN (MARQUE X)", COLORS.VERDE_OSCURO);
    createHeader(sheet, "AE4:AL4", "INFORMACIÓN FAMILIAR", COLORS.AZUL_MARINO);
    createHeader(sheet, "AM4:BH4", "INFORMACIÓN DEL PROYECTO VINCULADO", COLORS.CAFE_OSCURO);
    createHeader(sheet, "BI4:BL4", "DATOS DE CONTACTO DEL BENEFICIARIO", COLORS.GRIS);
    createHeader(sheet, "BM4:BN4", "CONECTIVIDAD", COLORS.AZUL_OSCURO);
    createHeader(sheet, "BO4:BR4", "INFORMACIÓN ORGANIZACIONAL", COLORS.CAFE_OSCURO);
    createHeader(sheet, "BS4:BW4", "VALIDACIÓN INTERNA ART", COLORS.AZUL_OSCURO);
    sheet.getRow(5).height = 70;
    createSubHeader(sheet, "A5", "", COLORS.AZUL_OSCURO);
    [
      "PRIMER NOMBRE",
      "SEGUNDO NOMBRE",
      "PRIMER APELLIDO",
      "SEGUNDO APELLIDO",
      "TIPO DE IDENTIFICACIÓN",
      "NO. DE IDENTIFICACIÓN",
      "SEXO",
      "FECHA DE NACIMIENTO",
      "¿SABE LEER Y ESCRIBIR? SI/NO",
      "INGRESOS MENSUALES (PESOS M/CTE)",
      "LÍNEA ECONÓMICA PRINCIPAL",
    ].forEach((t, i) =>
      createSubHeader(sheet, sheet.getCell(5, 2 + i).address, t, COLORS.AZUL_CLARO)
    );

    ["NINGUNA", "PRIMARIA", "SECUNDARIA", "TÉCNICA", "PROFESIONAL"]
      .forEach((t, i) =>
        createSubHeader(sheet, sheet.getCell(5, 13 + i).address, t, COLORS.MARRON_CLARO)
      );

    [
      "CAMPESINO", "COMUNIDAD INDÍGENA", "COMUNIDAD NARP", "COMUNIDAD ROM",
      "VÍCTIMA", "DISCAPACIDAD", "LGBT+", "MUJER RURAL", "JOVEN RURAL",
      "ADULTO MAYOR", "REINCORPORADO", "OTRO", "¿CUÁL?",
    ].forEach((t, i) =>
      createSubHeader(sheet, sheet.getCell(5, 18 + i).address, t, COLORS.VERDE_CLARO)
    );

    [
      "ES CABEZA DE FAMILIA (SI/NO)", "NO. PERSONAS A CARGO",
      "TOTAL NÚCLEO FAMILIAR", "ESTADO CIVIL",
      "NOMBRE COMPLETO CÓNYUGE", "TIPO ID DEL CÓNYUGE",
      "NO. ID DEL CÓNYUGE", "NÚMERO DE CONTACTO DEL CÓNYUGE",
    ].forEach((t, i) =>
      createSubHeader(sheet, sheet.getCell(5, 31 + i).address, t, COLORS.AZUL_CLARO_2)
    );

    [
      "CÓDIGO PROYECTO ART", "NOMBRE DEL PROYECTO", "SUBREGIÓN PDET", "DEPARTAMENTO", "MUNICIPIO",
      "TIPO ZONA INFLUENCIA DIRECTA", "NOMBRE ZONA INFLUENCIA", "CÓDIGO SHAPE VEREDAS",
      "PREDIO / FINCA", "TENENCIA", "LATITUD", "LONGITUD",
      "NO. HECTÁREAS PROYECTO", "LÍNEA PRODUCTIVA",
      "VARIEDAD", "NO. HECTÁREAS", "PRODUCCIÓN ANUAL",
      "DISTANCIA (KM)", "TIEMPO (MIN)", "MEDIO TRANSPORTE",
      "¿VIVE EN EL PROYECTO?", "LUGAR DE VIVIENDA",
    ].forEach((t, i) =>
      createSubHeader(sheet, sheet.getCell(5, 39 + i).address, t, COLORS.CAFE_CLARO)
    );
    ["DIRECCIÓN DE CORRESPONDENCIA", "TELÉFONO CONTACTO 1", "TELÉFONO CONTACTO 2", "CORREO ELECTRÓNICO"]
      .forEach((t, i) =>
        createSubHeader(sheet, sheet.getCell(5, 61 + i).address, t, COLORS.GRIS_CLARO)
      );
    ["TELEFÓNICA SI/NO", "INTERNET SI/NO"]
      .forEach((t, i) =>
        createSubHeader(sheet, sheet.getCell(5, 65 + i).address, t, COLORS.AZUL_CLARO_2)
      );
    [
      "¿VINCULADO A ORGANIZACIÓN?", "TIPO DE ORGANIZACIÓN",
      "NOMBRE DE LA ORGANIZACIÓN", "ORGANIZACIÓN DE MUJERES SI/NO",
    ].forEach((t, i) =>
      createSubHeader(sheet, sheet.getCell(5, 67 + i).address, t, COLORS.AMARILLO_CLARO)
    );
    [
      "VALIDADO REGISTRADURÍA", "VALIDADO PROCURADURÍA", "VALIDADO POLICÍA",
      "ESTADO DEL PROYECTO", "OBSERVACIÓN ESTADO",
    ].forEach((t, i) =>
      createSubHeader(sheet, sheet.getCell(5, 71 + i).address, t, COLORS.AZUL_CLARO_2)
    );
    let startRow = 6;

    participantesValidados.forEach((p, index) => {
      const row = sheet.getRow(startRow + index);
      row.getCell(1).value = p.no;
      row.getCell(2).value = p.nombre_1;
      row.getCell(3).value = p.nombre_2;
      row.getCell(4).value = p.apellido_1;
      row.getCell(5).value = p.apellido_2;
      row.getCell(6).value = p.tipo_identificacion;
      row.getCell(7).value = p.numero_identificacion;
      row.getCell(8).value = p.sexo;
      row.getCell(9).value = p.fecha_nacimiento;
      row.getCell(10).value = p.sabe_leer_escribir;
      row.getCell(11).value = p.ingresos_mensuales;
      row.getCell(12).value = p.linea_economica_principal;

      row.getCell(13).value = p.ninguna;
      row.getCell(14).value = p.primaria;
      row.getCell(15).value = p.secundaria;
      row.getCell(16).value = p.tecnica;
      row.getCell(17).value = p.profesional;
      row.getCell(18).value = p.Campesino;
      row.getCell(19).value = p.Comunidad_Indigena;
      row.getCell(20).value = p.Comunidad_NARP;
      row.getCell(21).value = p.Comunidad_ROM;
      row.getCell(22).value = p.Victima;
      row.getCell(23).value = p.Discapacidad;
      row.getCell(24).value = p.LGBT_plus;
      row.getCell(25).value = p.Mujer_Rural;
      row.getCell(26).value = p.Joven_Rural;
      row.getCell(27).value = p.Adulto_Mayor;
      row.getCell(28).value = p.Reincorporado;
      row.getCell(29).value = p.Otro;

      row.getCell(31).value = p.cabeza_familia;
      row.getCell(32).value = p.num_personas_cargo;
      row.getCell(33).value = p.total_nucleo_familiar;
      row.getCell(34).value = p.estado_civil;
      row.getCell(35).value = p.nombre_conyuge;
      row.getCell(36).value = p.tipo_id_conyuge;
      row.getCell(37).value = p.identificacion_conyuge;
      row.getCell(38).value = p.numero_contacto_conyuge;

      row.getCell(39).value = p.codigo_proyecto;
      row.getCell(40).value = p.nombre_proyecto;
      row.getCell(41).value = p.nombre_subregion_pdet;
      row.getCell(42).value = p.departamento;
      row.getCell(43).value = p.municipio;
      row.getCell(44).value = p.tipo_zona_influencia;
      row.getCell(45).value = p.zona_influencia;
      row.getCell(46).value = p.codigo_shape;
      row.getCell(47).value = p.nombre_predio;
      row.getCell(48).value = p.relacion_tenencia_predio;
      row.getCell(49).value = p.latitud;
      row.getCell(50).value = p.longitud;
      row.getCell(51).value = p.num_hectarias_proyecto;
      row.getCell(52).value = p.linea_productiva;
      row.getCell(53).value = p.variedad_establecida;
      row.getCell(54).value = p.num_hectareas;
      row.getCell(55).value = p.produccion_anual;
      row.getCell(56).value = p.distancia_cabecera_municipal;
      row.getCell(57).value = p.tiempo_cabecera_municipal;
      row.getCell(58).value = p.medio_trasporte;
      row.getCell(59).value = p.vive_proyecto;
      row.getCell(60).value = p.lugar_vivienda;
      row.getCell(61).value = p.direccion_correspondencia;
      row.getCell(62).value = p.numero_telefonico_1;
      row.getCell(63).value = p.numero_telefonico_2;
      row.getCell(64).value = p.correo_electronico;
      row.getCell(65).value = p.telefonica;
      row.getCell(66).value = p.internet;
      row.getCell(67).value = p.vinculado_org;
      row.getCell(68).value = p.tipo_org;
      row.getCell(69).value = p.nombre_org;

      row.getCell(70).value = p.org_mujeres;
      row.getCell(71).value = p.validado_registraduria;
row.getCell(72).value = p.validado_procuraduria;
row.getCell(73).value = p.validado_policia;
      row.getCell(74).value = p.estado_proyecto;
      row.getCell(75).value = p.observacion_estado;

      row.eachCell((cell) => withSoftBorder(cell));
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Formato_ART_Completo.xlsx");
  };

  return (
    <Button type="primary" icon={<DownloadOutlined />} onClick={exportExcel}>
      Exportar Participantes Finales
    </Button>
  );
};

export default ExportExcelBodecom;
